<template>
  <div class="section">
    <h2 :class="['title title--3 no-wrap-ellipsis', { 'extra-spacing': searchResults.length > 0 }]">
      {{ searchResults.length }} Search Result<template v-if="searchResults.length !== 1">s</template> for <b>"{{ searchTerm }}"</b>
    </h2>

    <div
      v-if="searchResults.length > 0"
      class="menu-list menu-list--basic"
    >
      <div class="menu-list__items">
        <menu-list-item
          v-for="item in searchResults"
          :key="item.menuItemId"
          :item="item"
          :read-only="isReadOnly"
          @open-item="handleMenuItemClick(item)"
        />
      </div>
    </div>
  </div>
</template>


<script>
  import MenuListItem from './menu-list-item.vue';

  export default {
    name: 'MenuSearchFilterResults',

    components: {
      MenuListItem
    },

    props: {
      isReadOnly: {
        type: Boolean,
        default: false
      },

      searchTerm: {
        type: String,
        default: ''
      },

      searchResults: {
        type: Array,
        default() {
          return [];
        }
      }
    },

    methods: {
      handleMenuItemClick(item) {
        this.$emit('open-menu-item', item);
      }
    }
  };
</script>
